import strings from '../../../globalization';
export const editFormData = () => {
  return [
    {
      elementType: 'text',
      // keyboardType: 'default',
      inputType: 'name',
      label: strings.masterAdminName,
      placeholder: strings.masterAdminNamePlaceholder,
      required: true,
      //name: 'name',
      stateField: 'name',
      error: ' At Least Four Characters Required',
      stateDefault: '',
      minLength: 4,
      maxLength: 120,
      dependentOnOtherFields: false,
    },
    {
      elementType: 'text',
      //keyboardType: 'default',
      inputType: 'name_hindi',
      // name: 'name_hindi',
      label: strings.masterAdminNameHindi,
      placeholder: strings.masterAdminNameHindiPlaceholder,
      error: ' At Least Four Characters Required',
      required: true,
      stateField: 'name_hindi',
      stateDefault: '',
      minLength: 4,
      maxLength: 120,
      dependentOnOtherFields: false,
    },

    {
      elementType: 'dropdown',
      inputType: 'text',
      label: 'Pass Category',
      placeholder: 'Select Pass Category',
      optionsField: 'passCategories',
      required: true,
      stateField: 'passCategoryId',
      stateDefault: null,
      maxLength: 20,
      error: 'Field is required',
      dependentOnOtherFields: false,
    },
    {
      elementType: 'dropdown',
      inputType: 'text',
      label: 'Pack Type',
      placeholder: 'Select Pack Type',
      optionsField: 'availabelPacks',
      required: true,
      stateField: 'packType',
      stateDefault: null,
      maxLength: 20,
      error: 'Field is required',
      dependentOnOtherFields: false,
    },
    {
      elementType: 'dropdown',
      inputType: 'text',
      label: 'Status',
      placeholder: 'Select Status',
      optionsField: 'statuses',
      required: true,
      stateField: 'status',
      stateDefault: null,
      maxLength: 20,
      error: 'Field is required',
      dependentOnOtherFields: false,
    },
  ];
};
